export const footerMenuStyleGenerator = ({
  serverAppTheme,
  isDriveThru,
  isPreAuth,
  isPaymentDisabled,
  cart,
  isWalkUp,
}) => {
  const footerParentContainer = {
    height: isDriveThru ? '44px' : '100%',
    marginTop: !isDriveThru && '0.25rem',
  };

  const printButtonStyle = isPreAuth
    ? {
      minWidth: '27%',
      backgroundColor:
        cart.length > 0
          ? serverAppTheme?.secondaryBtnDisabled
          : serverAppTheme?.secondaryBtn,
      color:
        cart.length > 0
          ? serverAppTheme?.btn_font_color
          : serverAppTheme?.btn_font_color_disabled,
      marginRight: '0.25rem',
      opacity: 1,
    }
    : {
      minWidth: '32.5%',
      backgroundColor:
        cart.length > 0
          ? serverAppTheme?.secondaryBtnDisabled
          : serverAppTheme?.secondaryBtn,
      color:
        cart.length > 0
          ? serverAppTheme?.btn_font_color_disabled
          : serverAppTheme?.btn_font_color,
      marginRight: '0.25rem',
      opacity: 1,
    };

  const preAuthButtonStyle = {
    minWidth: isPreAuth ? '27%' : '36%',
    backgroundColor: serverAppTheme?.secondaryBtn,
    marginRight: '0.25rem',
  };

  const stageButtonStyle = isPreAuth
    ? { minWidth: '20%', marginRight: '0.25rem' }
    : { minWidth: '32.8%' };

  const payButtonStyle = isPreAuth
    ? isWalkUp
      ? {
        width: '100%',
        backgroundColor: isPaymentDisabled
          ? serverAppTheme?.disabledPayBtn
          : serverAppTheme?.enabledPayBtn,
        color: isPaymentDisabled
          ? serverAppTheme?.btn_font_color_disabled
          : serverAppTheme?.btn_font_color,
      }
      : {
        minWidth: '20%',
        backgroundColor: isPaymentDisabled
          ? serverAppTheme?.disabledPayBtn
          : serverAppTheme?.enabledPayBtn,
        color: isPaymentDisabled
          ? serverAppTheme?.btn_font_color_disabled
          : serverAppTheme?.btn_font_color,
      }
    : {
      minWidth: '32.5%',
      backgroundColor: isPaymentDisabled
        ? serverAppTheme?.disabledPayBtn
        : serverAppTheme?.enabledPayBtn,
      color: isPaymentDisabled
        ? serverAppTheme?.btn_font_color_disabled
        : serverAppTheme?.btn_font_color,
    };
  return {
    footerParentContainer,
    printButtonStyle,
    preAuthButtonStyle,
    stageButtonStyle,
    payButtonStyle,
  };
};
